import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M12.5 18.16q-1.228 0-2.182-.421-.95-.42-1.5-1.17a3.03 3.03 0 0 1-.586-1.734h2.137q.028.473.312.824.284.347.756.54a2.8 2.8 0 0 0 1.057.193q.625 0 1.108-.216a1.8 1.8 0 0 0 .755-.613q.273-.393.267-.904a1.57 1.57 0 0 0-.272-.932q-.279-.403-.807-.63-.524-.228-1.262-.228h-1.028v-1.625h1.028q.609 0 1.063-.21.46-.21.722-.59.261-.387.255-.893.006-.494-.221-.858a1.5 1.5 0 0 0-.631-.574 2.1 2.1 0 0 0-.949-.204 2.5 2.5 0 0 0-.989.193 1.8 1.8 0 0 0-.733.551 1.4 1.4 0 0 0-.295.841H8.477q.022-.977.562-1.716a3.63 3.63 0 0 1 1.455-1.159q.909-.42 2.04-.42 1.164 0 2.022.437.863.432 1.335 1.165.472.732.472 1.62.005.982-.58 1.647-.58.665-1.522.87v.09q1.227.17 1.88.91.66.732.654 1.823a2.92 2.92 0 0 1-.557 1.75q-.55.767-1.523 1.205-.965.437-2.216.437Z"
    }, null, -1)
  ])))
}
export default { render: render }